import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
	CardImg,
	CardSubtitle,
	Modal,
	ModalHeader,
	ModalBody,
	Button,
} from 'reactstrap';

import {
	deleteSingleApk,
	fetchApps, fetchCheckedAppsInfo,
	filteringApps, getInRetailAppsList,
	localGetSelectedApps,
	localSaveSelectedApps, saveInRetailAppsList,
	uploadNewApk
} from '../../actions/marketActions';
import {API_BASE_URL, GUEST} from '../../helpers/constants';
import AttributesList from '../AttributesList/AttributesList';
import {I18n} from '../../I18n/components/apk';
import {push} from 'connected-react-router';

import './apk.css';
import {fetchCompanies} from "../../actions/companyActions";
import {closeAlert} from "../../actions/commonsActions";

class Apk extends Component {
	constructor(props) {
		super(props);
	}

	updateAttributesList = attributes => {
		this.props.updateApkAttributesList(attributes);
		this.props.toggleApkModal();
	}

	render() {
		const {lang} = this.props;
		return (
			<Modal className="apk-modal" isOpen={this.props.apkModal} toggle={this.props.toggleApkModal}>
				<div className="apk-modal__top">
				<CardImg top width="10%"
					 className="apk-modal__image"
					 alt={this.props.apk ? this.props.apk.originalApkFilename : ""}
					 src={this.props.apk  && this.props.apk.id ? `${API_BASE_URL}/apps/apks/download/icon/${this.props.apk.id}` : "#"}/>
				</div>
				<ModalHeader>{this.props.apk ? this.props.apk.originalApkFilename : ""}</ModalHeader>
				<ModalBody>
					<CardSubtitle className="apk-modal__subtitle">{I18n[lang].arc} {this.props.apk ? this.props.apk.supportedArchitectures : ""}</CardSubtitle>
					<CardSubtitle className="apk-modal__subtitle apk-modal__subtitle_attr">{I18n[lang].attributes}</CardSubtitle>
					{
						this.props.apkModal ? (
							<AttributesList
								attributes={this.props.attributes}
								updateAttributesList={this.updateAttributesList}
								toggleApkModal={() => {this.props.toggleApkModal()}}
								authority={this.props.authority}
							/>) : (<div></div>)
					}
				</ModalBody>
			</Modal>
		)
	}
}

const mapDispatchToProps = dispatch => {
	return {
	};
};

const mapStateToProps = state => ({
	lang: state.languageReducer.lang
});

export default connect(mapStateToProps, mapDispatchToProps)(Apk)



// WEBPACK FOOTER //
// ./src/components/Apk/Apk.js